export interface LiveItem {
  id: string;
  title: string;
  anchor: string;
  thumbnail: string;
  category: string;
  viewers: string;
  hot?: boolean;
  streamUrl?: string;
}

export const useLives = () => {
  const items = ref<LiveItem[]>([]);
  const loading = ref(false);

  const load = async (params?: { category?: string; anchor?: string; hot?: boolean }) => {
    loading.value = true;
    try {
      items.value = [];
    } finally {
      loading.value = false;
    }
  };

  return { items, loading, load };
};
